import * as UIRepository from "repository/UIRepository";

export const getUI = (projectId) => {
    const windows = UIRepository.getWindows(projectId);
    const disclaimerConfirmed = isDisclaimerConfirmed(projectId);

    return {windows, disclaimerConfirmed}
}

export const setWindows = (windows, projectId) => {
    return UIRepository.setWindows(windows, projectId)
}

export const isDisclaimerConfirmed = (projectId) => {
    const disclaimers = UIRepository.getDisclaimers();
    return disclaimers.length > 0 && disclaimers.includes(projectId)
}

export const confirmDisclaimer = (projectId) => {
    let disclaimers = UIRepository.getDisclaimers();
    if (!disclaimers.includes(projectId)) disclaimers.push(projectId);

    UIRepository.setDisclaimers(disclaimers);
}